<template>
  <div class="coupon-item" :class="{ gradient, disabled: getCouponStatus !== 0 }">
    <div class="left">
      <div class="name">{{ getCouponType }}</div>
      <div class="desc">{{ item.instructions }}</div>
      <div class="time">
        {{ moment(item.validity_start_time * 1000).format("YYYY-MM-DD") }} -
        {{ moment(item.validity_end_time * 1000).format("YYYY-MM-DD") }}
      </div>
    </div>
    <div class="right">
      <div class="price">
        <span v-if="item.coupon_type === 1">￥{{ item.coupon_amount }}</span>
        <span v-if="item.coupon_type === 2">免费</span>
        <span v-if="item.coupon_type === 3">{{ item.discount }}折</span>
        <span v-if="item.coupon_type === 4"
          >￥{{ item.vip_coupon_amount }}</span
        >
      </div>
      <div class="button" @click="handleGet">{{ getButtonText }}</div>
    </div>
  </div>
</template>
<script setup>
import { computed } from "vue";
import moment from "moment";

const props = defineProps({
  item: {
    type: Object,
    default: () => ({}),
  },
  gradient: {
    type: Boolean,
    default: false,
  },
  buttonText: {
    type: String,
    default: "立即领取",
  },
});
const emit = defineEmits(["clickButton"]);
function handleGet() {
  if (getCouponStatus.value !== 0 && props.item.coupon_type !== 2) return;
  emit("clickButton", props.item);
}

const getCouponStatus = computed(() => {
  const endTime = moment(props.item.validity_end_time * 1000).format(
    "YYYY-MM-DD"
  );
  if (props.item.is_use === 1) return 1;
  if (moment(endTime).isBefore(moment().format("YYYY-MM-DD"))) return 2;
  return 0;
});
const getButtonText = computed(() => {
  return {
    0: props.buttonText,
    1: "已使用",
    2: "已过期",
  }[getCouponStatus.value];
});
const getCouponType = computed(() => {
  // 1=现金券,2=赠送券,3=折扣券,4=VIP折扣券
  return {
    1: "现金券",
    2: "赠送券",
    3: "折扣券",
    4: "VIP折扣券",
  }[props.item.coupon_type];
});
</script>
<style scoped lang="less">
.coupon-item {
  margin-top: 12px;
  border-radius: 8px;
  background: #fff;
  border: 1px solid rgba(232, 232, 232, 1);
  display: flex;
  justify-content: space-between;
  padding: 12px;

  &.gradient {
    background: linear-gradient(90deg, #ffffff 0%, #fff2f2 100%);
  }

  &.disabled {
    background: #f5f5f5;

    .right {
      .button {
        background-color: #cdcdcd;
      }
    }
  }

  &:first-child {
    margin-top: 0;
  }

  .left {
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    .name {
      font-size: 20px;
      color: #ff8d1a;
      font-weight: 500;
    }

    .desc {
      font-size: 12px;
      color: #808080;
      padding: 8px 8px 8px 0;
    }

    .time {
      font-size: 12px;
      color: #cfcfcf;
    }
  }

  .right {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: flex-end;

    .price {
      color: #ff8d1a;
      font-size: 28px;
      font-weight: 500;
      width: 100%;
      text-align: center;
      line-height: 36px;
    }

    .button {
      color: #fff;
      background-color: @theme-color;
      height: 28px;
      width: 80px;
      border-radius: 80px;
      font-size: 14px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
}
</style>
